export default "__VITE_ASSET__BME92TcW__"